<?php

Namespace View;

class HomeView extends \Core\View
{

    public function display($data)
    {
        $tplfunc = \Core\View::$template;
        $tpl_data = \Core\View::parse_view_template($tplfunc);
        \Core\View::execute_view_template('#template', $tpl_data);
    }

    public function displayAccounts($binder)
    {
        \ISOPHP\js_core::$console->log('display accounts');
        $jQuery = \ISOPHP\js_core::$jQuery;
        $tplfunc = \Core\View::$template;
        \ISOPHP\js_core::$console->log('pl func', $tplfunc);
        $tpl_data = $tplfunc();
//        \ISOPHP\js_core::$console->log('davey ravey don display accounts', $tpl_data) ;
        $jQuery('#home_summary_accounts')->html($tpl_data);
        \ISOPHP\js_core::$console->log('binding');
        $binder();
    }



}


// WEBPACK FOOTER //
// app/Home/View/HomeView.php